import script from "./UserReferrals.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserReferrals.vue?vue&type=script&setup=true&lang=ts"

import "./UserReferrals.vue?vue&type=style&index=0&id=d0c46a04&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0c46a04"]])

export default __exports__